module.exports = __webpack_public_path__ + "static/card-commisioner-bobby-olvera-2-220569c1489eacdabcfe9b935b1206c6.jpg";